import React from "react";
import Jumbotron from "../../components/Jumbotron";
import ModalList from "../../components/ModalList";
import "./Home.css";

const Home = () => {
  return (
    <>
      <Jumbotron />
      <ModalList />
    </>
  );
};

export default Home;
